import { styled, css } from 'styled-components';
import { Icon } from '../Icon';
import { StateLayer } from '../../core-components';
import { Divider } from '../Divider';
export const AccordionElement = styled.div.withConfig({
  componentId: "aui__sc-1q91igw-0"
})(["display:flex;justify-content:space-evenly;align-items:center;flex-direction:column;", ";overflow:hidden;width:100%;color:var(--aui-on-surface);"], ({
  $variant
}) => $variant === 'inline' && css(["border:1px solid var(--aui-outline);border-radius:var(--aui-border-radius-100);"]));
export const AccordionSectionWrapper = styled.div.withConfig({
  componentId: "aui__sc-1q91igw-1"
})(["overflow:hidden;width:100%;", ";"], ({
  $variant
}) => $variant === 'inline' && css(["&:last-child ", "{display:none;}"], AccordionDivider));
export const ButtonElement = styled.button.withConfig({
  componentId: "aui__sc-1q91igw-2"
})(["all:unset;position:relative;cursor:pointer;width:100%;box-sizing:border-box;display:flex;gap:var(--aui-spacing-100);align-items:center;padding:var(--aui-spacing-200);&:hover:not(:disabled) ", "{opacity:var(--aui-state-layer-hover);}&:active:not(:disabled) ", "{opacity:var(--aui-state-layer-press);}"], StateLayer, StateLayer);
export const AccordionSectionText = styled.div.withConfig({
  componentId: "aui__sc-1q91igw-3"
})(["line-height:1.3;flex-grow:1;padding-right:var(--aui-spacing-100);display:flex;flex-direction:column;gap:var(--aui-spacing-050);"]);
export const AccordionSectionContent = styled.div.withConfig({
  componentId: "aui__sc-1q91igw-4"
})(["opacity:", ";visibility:", ";overflow-y:hidden;line-height:1.3;padding-right:var(--aui-spacing-150);padding-bottom:", ";padding-left:", ";", ";@keyframes open{from{max-height:0;}99%{max-height:100vh;}to{max-height:unset;}}@keyframes close{from{max-height:100vh;}to{max-height:0;}}"], ({
  $isOpen
}) => $isOpen ? '100%' : '0', ({
  $isOpen
}) => $isOpen ? 'visible' : 'hidden', ({
  $isOpen
}) => $isOpen ? 'var(--aui-spacing-150)' : '0', ({
  $hasLeader
}) => $hasLeader ? 'var(--aui-spacing-600)' : 'var(--aui-spacing-200)', getTransitionStyles);
function getTransitionStyles({
  $isOpen,
  $shouldAnimate,
  $transitionDuration,
  $transitionTimingFunction
}) {
  let styles = `transition: all ${$transitionDuration} ${$transitionTimingFunction};`;
  if ($shouldAnimate) {
    styles += `animation: ${$isOpen ? 'open' : 'close'} ${$transitionDuration} ${$transitionTimingFunction};`;
  }
  if (!$isOpen) {
    styles += 'max-height: 0;';
  }
  return styles;
}
export const Leader = styled.div.withConfig({
  componentId: "aui__sc-1q91igw-5"
})(["align-self:flex-start;flex-shrink:0;width:var(--aui-spacing-300);"]);
export const AccordionDivider = styled(Divider).withConfig({
  componentId: "aui__sc-1q91igw-6"
})(["border-color:var(--aui-outline);"]);
export const RotatingIcon = styled(Icon.SSR).withConfig({
  componentId: "aui__sc-1q91igw-7"
})(["overflow:hidden;flex-shrink:0;transition:all 0.4s ease-in-out;transform:", ";"], ({
  $rotateIcon
}) => `rotate(${$rotateIcon ? -180 : 0}deg)`);